// ─────────────────────────────────────────────────────────────────────────────
// authHeaders — the ONE auth idiom for every dashboard feed.
//
// Owner ruling 2026-07-31 ("one core, every window"): the portrait phone surface
// and the landscape desktop share their wiring; only layout differs. This was
// previously re-typed inline in all seven panels — one copy per surface would be
// two copies, and two copies drift.
//
// The IMPLEMENTATION now lives in ./endpoints.js (owner ruling 2026-08-01). The
// phone surface is the Claude Design document, served unbuilt out of public/, so
// it cannot import anything CRA compiles — plain JS is the only form both sides
// can read. This module re-exports it UNCHANGED, so every existing import in the
// seven panels keeps resolving to the exact same function and cadence.
//
// The token is injected on `window.__rexyToken` by the shell (unchanged contract).
// ─────────────────────────────────────────────────────────────────────────────

export { authHeaders, POLL_MS } from './endpoints';
